import { TableHead as MUITableHead, TableHeadProps } from '@mui/material';

export { type TableHeadProps } from '@mui/material';

export function TableHead(props: TableHeadProps) {
  return <MUITableHead {...props} />;
}
